<!-- MODULO SLIDER -->
<!-- FIX: questo componente scrolla leggermente in basso. non riesco a correggerlo, vedere se è possibile una componente angular simile -->
<div class="container modulo modulo-slider mb-5">
  <div class="row">
    <div class="col-12 offset-md-1 col-md-10">
      <div class="row">
        <div class="col-12">
          <img *ngIf="campi.GALLERIA_FOTOGRAFICA?.valore.length > 0" class="img-fluid" [appSrcDesktopLandscape169]="campi.GALLERIA_FOTOGRAFICA.valore[0].path" [alt]='campi.GALLERIA_FOTOGRAFICA.valore[0].alt' (click)="openFotoIndex = 0">
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 ">
          <div class="d-inline-flex img-galleria mr-2" *ngIf="campi.GALLERIA_FOTOGRAFICA?.valore.length > 1">
            <img [appSrcMobileLandscape43]="campi.GALLERIA_FOTOGRAFICA.valore[1].path" [alt]='campi.GALLERIA_FOTOGRAFICA.valore[1].alt' class="" (click)="openFotoIndex = 1">
          </div>
          <div class="d-inline-flex img-galleria mr-2" *ngIf="campi.GALLERIA_FOTOGRAFICA?.valore.length > 2">
            <img [appSrcMobileLandscape43]="campi.GALLERIA_FOTOGRAFICA.valore[2].path" [alt]='campi.GALLERIA_FOTOGRAFICA.valore[2].alt' class="" (click)="openFotoIndex = 2">
          </div>
          <div class="d-inline-flex img-galleria mr-2" *ngIf="campi.GALLERIA_FOTOGRAFICA?.valore.length > 3">
            <img [appSrcMobileLandscape43]="campi.GALLERIA_FOTOGRAFICA.valore[3].path" [alt]='campi.GALLERIA_FOTOGRAFICA.valore[3].alt' class="" (click)="openFotoIndex = 3">
          </div>
          <div class="d-inline-flex img-galleria mr-2" *ngIf="campi.GALLERIA_FOTOGRAFICA?.valore.length > 4">
            <img [appSrcMobileLandscape43]="campi.GALLERIA_FOTOGRAFICA.valore[4].path" [alt]='campi.GALLERIA_FOTOGRAFICA.valore[4].alt' class="" (click)="openFotoIndex = 4">
          </div>
          <div class="d-inline-flex img-galleria mr-2" *ngIf="campi.GALLERIA_FOTOGRAFICA?.valore.length > 5" (click)="openFotoIndex = 5">
            <div class="ultima-img text-center">
              <span class="position-relative">+{{campi.GALLERIA_FOTOGRAFICA.length - 4}}</span>
            </div>
            <img [appSrcMobileLandscape43]="campi.GALLERIA_FOTOGRAFICA.valore[4].path" [alt]='campi.GALLERIA_FOTOGRAFICA.valore[4].alt' class="">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- //MODULO SLIDER -->

<app-galleria-fotografica *ngIf="campi.GALLERIA_FOTOGRAFICA?.valore" [foto]="campi.GALLERIA_FOTOGRAFICA.valore" [(openFotoIndex)]="openFotoIndex"></app-galleria-fotografica>
